export default "__VITE_ASSET__CFKq$7mN__"